import styled from "styled-components";

// const Flex = styled.div`
//   display: flex;
// `;

// const Row = styled(Flex)`
//   flex-direction: row;
//   align-items: center;
// `;

// const RowSpaceBetween = styled(Row)`
//   justify-content: space-between;
// `;

// const FitWidth = styled.div`
//   width: 100%;
// `;

// const Container = styled.div`
//   padding: 1em;
// `;

const Div = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const ClientLogo = styled.img`
  margin: 1px -9px;
  display: block;
  width: auto;
  height: 56px;
  float: right;
  font-size: 1rem;
  background: url("images/image-loader.gif") center center no-repeat transparent;
`;

export { ClientLogo, Div };
